import { Tab, Tabs } from "@mui/material";
import React, { useEffect, useState } from "react";
import { postRequest } from "services/api";
import { useSelector } from "react-redux";

import RouteOrder from "./RouteOrder";
import BulkOrdersTabPanel from "./BulkOrdersTabPanel";
import WaitingForRouting from "./WaitingForRouting";
import RoutingRecieved from "./RoutingRecieved";

const BulkOrderTabs = ({navData}) => {
  const [value, setValue] = useState(0);
 
  const { user } = useSelector(state => state.user);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const navMenu = navData;

  const checkMenuPermission = (name) => {
    return navMenu && navMenu.some((menu) => menu.menuName.includes(name));
  };

  const a11yProps = (index) => {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  };
  return (
    <div className="dashboard-tabs-wrapper" style={{position:"relative"}}>
      <div className="dashboard-tabs">
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
          sx={{
            "& button": {
              borderRadius: "25px",
              backgroundColor: "#e5eaf0",
              padding: "10px 18px",
              minHeight: "36px",
              marginRight:"10px"
            },
            "& button:hover": { backgroundColor: "#a878e6", color: "#fff" },
            "& button:active": { backgroundColor: "#a878e6", color: "#fff" },
            "& button.Mui-selected": {
              backgroundColor: "#a878e6",
              color: "#fff",
            },
          }}
          TabIndicatorProps={{ hidden: true }}
        >
          
          <Tab label="Route Order" {...a11yProps(0)} />
          <Tab label="Waiting for Routing" {...a11yProps(1)} />
          <Tab label="Routing Received" {...a11yProps(2)} />
         
          
        </Tabs>
      </div>
      <BulkOrdersTabPanel value={value} index={0}>
        <RouteOrder/>
      </BulkOrdersTabPanel>

      <BulkOrdersTabPanel value={value} index={1}>
        <WaitingForRouting/>
      </BulkOrdersTabPanel>

      <BulkOrdersTabPanel value={value} index={2}>
        <RoutingRecieved />
      </BulkOrdersTabPanel>
      
      
    </div>
  );
};

export default BulkOrderTabs;
